export function menu() {
  let menu = {
    home: {
      display: 'Home',
      link: '/',
      order: 1
    },
    'our-story': {
      display: 'Our Story',
      link: '/our-story',
      order: 2
    },
    newyork: {
      display: 'Afterschool',
      link: '/newyork',
      order: 3
    },
    camps: {
      display: 'Camps',
      link: '/camps',
      order: 4,
      anchor: [
        {
          name: 'sempai',
          link: '/sempai'
        },
        {
          name: 'kohai',
          link: '/kohai'
        }
        // {
        //   name: 'gallery',
        //   link: '/camp/2016'
        // }
      ]
    },
    digital: {
      display: 'Digital Learning',
      link: '/digital',
      order: 5
    },
    'get-involved': {
      display: 'Get Involved',
      link: '/get-involved',
      order: 6
    }
  }
  return menu
}
//
// - key: home
//   data:
//     - display: Home
//       link: /
//       order: 1
// - key: our-story
//   data:
//     - display: Our Story
//       link: /our-story
//       order: 2
// - key: camps
//   data:
//     display: Camps
//     link: /camps
//     order: 3
//     anchor: true
//       - first:
//         name: sempai
//         link: /sempai
//       - second:
//         name: kohai
//         link: /kohai
//       - third:
//         name: gallery
//         link: /camp/2016



// WEBPACK FOOTER //
// ./src/modules/menu.js